import "./App.css";
import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import NoteState from "./context/notes/NoteState";
import Alert from "./components/Alert";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Addnote from "./components/Addnote";
import About from "./components/About";
import LandingPage from "./components/LandingPage";


// AppWrapper gives Router access to inner App for useLocation
export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

// Actual App Component
function App() {
  const location = useLocation();

  // Routes where Navbar should be hidden
  const hideNavbarRoutes = ["/login", "/signup", "/", "/about"];
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

  // Alert State
  const [alert, setAlert] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
  });

  const showAlert = ({ type, title, message }) => {
    setAlert({ show: true, type, title, message });
  };

  return (
    <NoteState>
      {/* Navbar - Hidden on some routes */}
      {!shouldHideNavbar && <Navbar showAlert={showAlert} />}

      {/* Addnote should be globally available */}
      <Addnote showAlert={showAlert} />

      {/* Alert Notification System */}
      <Alert
        show={alert.show}
        type={alert.type}
        title={alert.title}
        message={alert.message}
        onClose={() => setAlert((prev) => ({ ...prev, show: false }))}
        autoClose={true}
        duration={3000}
      />

      <Routes>
        {/* Full-width Pages (no .container) */}
        <Route path="/" element={<LandingPage showAlert={showAlert} />} />
        <Route path="/about" element={<About showAlert={showAlert} />} />

        {/* Contained Routes */}
        <Route
          path="/home"
          element={
            <div className="container">
              <Home showAlert={showAlert} />
            </div>
          }
        />
        <Route
          path="/login"
          element={
            <div className="container">
              <Login showAlert={showAlert} />
            </div>
          }
        />
        <Route
          path="/signup"
          element={
            <div className="container">
              <Signup showAlert={showAlert} />
            </div>
          }
        />
      </Routes>
    </NoteState>
  );
}
